import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_187: DocMigration = {
  maxSchemaVersion: "0.0.187",
  description: "Add a field on props reflecting whether they came from the interior or exterior catalog",
  apply(json: any) {
    for (const propId in json.props) {
      const prop = json.props[propId];
      const parentId = prop.parentId;

      const room = json.rooms[parentId];

      if (!room) {
        // A prop with a parentId that doesn't map to a room can be deleted
        delete json.props[propId];
      } else {
        const roomType = room.type;
        const roomEnclosure = room.attributes?.roomEnclosure;

        const roomEnclosureDefault = isInteriorRoomEnclosure(defaultroomEnclosure[roomType]);
        const roomEnclosureOverride = roomEnclosure ? isInteriorRoomEnclosure(roomEnclosure) : undefined;

        const isInterior = roomEnclosureOverride ?? roomEnclosureDefault;

        prop.catalogType = isInterior ? "INTERIOR_PROP_CATALOG" : "EXTERIOR_PROP_CATALOG";
      }
    }

    return json;
  },
};

export default migration_0_0_187;

function isInteriorRoomEnclosure(roomEnclosure: string): boolean {
  if (roomEnclosure === "CONDITIONED" || roomEnclosure === "UNCONDITIONED") {
    return true;
  }
  return false;
}

const defaultroomEnclosure = {
  MASTER_BED: "CONDITIONED",
  MASTER_BATH: "CONDITIONED",
  MASTER_CLOSET: "CONDITIONED",
  MASTER_HALL: "CONDITIONED",
  MASTER_PASS: "CONDITIONED",
  MASTER_SEAT: "CONDITIONED",
  MASTER_SUITE: "CONDITIONED",
  MASTER_VESTIBULE: "CONDITIONED",
  SHOWER: "CONDITIONED",
  WATER_CLOSET: "CONDITIONED",
  BATH_HALL: "CONDITIONED",
  MASTER_VANITY: "CONDITIONED",
  BEDROOM: "CONDITIONED",
  BED_PASS: "CONDITIONED",
  REACH_CLOSET: "CONDITIONED",
  BED_CLOSET: "CONDITIONED",
  DINING: "CONDITIONED",
  GUEST_SUITE: "CONDITIONED",
  WALK_IN_CLOSET: "CONDITIONED",
  POWDER: "CONDITIONED",
  FORMAL_DINING: "CONDITIONED",
  FORMAL_LIVING: "CONDITIONED",
  KITCHEN: "CONDITIONED",
  KITCHEN_CABINETS: "CONDITIONED",
  DINING_NOOK: "CONDITIONED",
  REFRIGERATOR: "CONDITIONED",
  KITCHEN_HALL: "CONDITIONED",
  PANTRY: "CONDITIONED",
  LIVING: "CONDITIONED",
  LIBRARY: "CONDITIONED",
  SCREEN: "CONDITIONED",
  LIVING_HALL: "CONDITIONED",
  OFFICE: "CONDITIONED",
  BAY_WINDOW: "CONDITIONED",
  COAT_CLOSET: "CONDITIONED",
  BATHFULL: "CONDITIONED",
  BATHFULL_1_DOOR: "CONDITIONED",
  BATHHALF: "CONDITIONED",
  JJ_BATH: "CONDITIONED",
  BED_BATH: "CONDITIONED",
  BATHTUB: "CONDITIONED",
  ENTRY: "CONDITIONED",
  FOYER: "CONDITIONED",
  ENTRY_BUFFER: "CONDITIONED",
  OPEN_BELOW: "CONDITIONED",
  GENERAL: "CONDITIONED",
  GALLERY: "CONDITIONED",
  GENERAL_OPEN: "CONDITIONED",
  CLOSET: "CONDITIONED",
  SOLARIUM: "CONDITIONED",
  READING_NOOK: "CONDITIONED",
  FLEX: "CONDITIONED",
  CABINETS: "CONDITIONED",
  HALL: "CONDITIONED",
  HALL_NO_WINDOW: "CONDITIONED",
  HALL_NO_ENTRY: "CONDITIONED",
  STAIRS: "CONDITIONED",
  STAIRS_EDITOR: "CONDITIONED",
  CORNER_HALL: "CONDITIONED",
  HALL_CASED_OPENING: "CONDITIONED",
  GARAGE: "UNCONDITIONED",
  GARAGE_DETACH: "UNCONDITIONED",
  UTIL_HALL: "CONDITIONED",
  MECH: "CONDITIONED",
  MUDROOM: "CONDITIONED",
  DOG: "CONDITIONED",
  JUMP: "CONDITIONED",
  LAUNDRY: "CONDITIONED",
  WORKSHOP: "CONDITIONED",
  MUD_LAUNDRY: "CONDITIONED",
  FRONT_PORCH: "OPEN",
  REAR_PORCH: "OPEN",
  PATIO: "NONE",
  WALK: "NONE",
  BREEZEWAY: "OPEN",
  FIREPLACE: "CONDITIONED",
  FREESTANDING_FIREPLACE: "OPEN",
  PORTICO: "EXTERIOR",
  NONE: "CONDITIONED",
  CHASE: "CONDITIONED",
  LANDSCAPE: "NONE",
};
